export const equipmentDeploymentKeys = {
    all: ['equipment-deployment'] as const,
    events: (assetId: string, limit?: number) =>
        [...equipmentDeploymentKeys.all, 'events', assetId, limit ?? 20] as const,
}
